import { scrollToId, trackEvent } from "../lib/tracking";
import { ANDREA_PHONE, ANDREA_PHONE_DISPLAY, contactClick } from "../lib/contact";
import { SocialLinks } from "./SocialLinks";

const LINKS = [
  { label: "Your Child", id: "sleep-help-by-age" },
  { label: "Meet Andrea", id: "meet-andrea" },
  { label: "Questions", id: "sleep-questions" },
];

// Crawlable path to the five in-depth sleep pages (all five, incl. Denver).
const SUPPORT_LINKS = [
  { label: "Pediatric Sleep Consulting", href: "/pediatric-sleep-consultant" },
  { label: "Newborn Sleep", href: "/newborn-sleep-consultant" },
  { label: "Baby & Infant Sleep", href: "/baby-sleep-consultant" },
  { label: "Toddler Sleep", href: "/toddler-sleep-consultant" },
  { label: "Virtual Sleep Support", href: "/virtual-sleep-consultant" },
  { label: "Colorado Sleep Support", href: "/colorado-pediatric-sleep-consultant" },
  { label: "Sleep Guides", href: "/sleep-guides" },
  { label: "Denver Sleep Consultant", href: "/denver-sleep-consultant" },
  { label: "In-Home Sleep (Denver)", href: "/denver-in-home-sleep-consultant" },
];

export const Footer = ({ home = true }) => {
  // Same dual-mode as Nav: on the standalone SEO pages the homepage sections
  // don't exist, so these navigate back to the homepage anchors instead.
  const go = (id) => {
    if (home) scrollToId(id);
    else window.location.assign(id === "top" ? "/" : `/#${id}`);
  };

  return (
    <footer id="talk-with-andrea" data-testid="site-footer" className="scroll-mt-24 bg-inkdeep text-ivory border-t border-ivory/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <button
            data-testid="footer-logo"
            onClick={() => go("top")}
            className="text-left"
            aria-label="Back to top"
          >
            <span className="block font-serif font-light text-3xl sm:text-4xl leading-tight tracking-tight">
              The Nurtured Parent Co.
            </span>
            <span className="block mt-2 text-[10px] tracking-[0.35em] uppercase text-ivory/50">
              Pediatric Sleep Consulting
            </span>
          </button>
          <div className="flex flex-col gap-7">
            <div data-testid="footer-social">
              <span className="block text-[10px] tracking-[0.3em] uppercase text-ivory/40">
                Stay connected with Andrea
              </span>
              <p className="mt-3 text-xs text-ivory/50 max-w-[240px] leading-relaxed">
                Sleep support, encouragement, and practical guidance for every stage.
              </p>
              <SocialLinks location="footer" variant="dark" className="mt-3 -ml-2.5" />
            </div>
            <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-sm text-ivory/60 hover:text-ivory transition-colors duration-300"
                >
                  {l.label}
                </button>
              ))}
            </nav>
            <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Sleep support">
              <span className="w-full text-[10px] tracking-[0.3em] uppercase text-ivory/40">
                Sleep Support
              </span>
              {SUPPORT_LINKS.map((l) => (
                <a
                  key={l.href}
                  data-testid={`footer-sleep-${l.href.slice(1)}`}
                  href={l.href}
                  className="text-sm text-ivory/60 hover:text-ivory transition-colors duration-300"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-ivory/40">
            © {new Date().getFullYear()} The Nurtured Parent Co.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a
              data-testid="footer-email"
              href="mailto:thenurturedparentco@gmail.com"
              className="text-xs text-ivory/40 hover:text-ivory/80 transition-colors duration-300"
            >
              thenurturedparentco@gmail.com
            </a>
            {ANDREA_PHONE && (
              <>
                <a
                  data-testid="footer-call"
                  href={`tel:${ANDREA_PHONE}`}
                  onClick={(e) => {
                    trackEvent("call_andrea_click", { location: "footer" });
                    contactClick("call")(e);
                  }}
                  className="text-xs text-ivory/40 hover:text-ivory/80 transition-colors duration-300"
                >
                  Call: {ANDREA_PHONE_DISPLAY}
                </a>
                <a
                  data-testid="footer-text"
                  href={`sms:${ANDREA_PHONE}`}
                  onClick={(e) => {
                    trackEvent("text_andrea_click", { location: "footer" });
                    contactClick("text")(e);
                  }}
                  className="text-xs text-ivory/40 hover:text-ivory/80 transition-colors duration-300"
                >
                  Text Andrea
                </a>
              </>
            )}
            <a
              data-testid="footer-staff-login"
              href="/client-hub"
              className="text-[11px] text-ivory/30 hover:text-ivory/60 transition-colors duration-300"
            >
              Staff Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
